import { Button, Typography, CircularProgress, Box } from "@mui/material";
import { DrawerModal } from "../common/DrawerModal";

interface PopupDialogProps {
  open: boolean;
  onClose: () => void;
  message: React.ReactNode;
  onConfirm: () => void;
  isLoading: boolean;
  title: string;
}

export const PopupDialog: React.FC<PopupDialogProps> = ({
  open,
  onClose,
  message,
  onConfirm,
  isLoading,
  title,
}) => {
  return (
    <DrawerModal
      isOpen={open}
      onClose={onClose}
      anchor="bottom"
      onOpen={() => {}} // Empty function since we control opening externally
    >
      <Box sx={{ p: 2, minWidth: 300 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          {title}
        </Typography>
        <Typography sx={{ mb: 3 }}>{message}</Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            disabled={isLoading}
            sx={{
              mt: 1,
              mb: 0,
              borderRadius: 50,
              lineHeight: "unset",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            disabled={isLoading}
            sx={{
              mt: 1,
              mb: 0,
              color: "white",
              borderRadius: 50,
              bgcolor: "primary.main",
              lineHeight: "unset",
            }}
          >
            {isLoading ? <CircularProgress size={20} /> : "Delete"}
          </Button>
        </Box>
      </Box>
    </DrawerModal>
  );
};
